<template>
  <div>
    <div class="back-top">
      <ul>
        <li @click="toggleConsultPanel">
          <img src="../../assets/side1.png" alt="在线咨询" />
          在线咨询
        </li>
        <li class="weath-item">
          <img src="../../assets/side2.png" alt="微信咨询" />
          微信咨询
          <div class="weath-popup">
            <i>{{ sideCard.logoname }}</i>
            <img
              :src="BASE_URL + sideCard.logourl"
              alt=""
              style="width: 118px; height: 118px"
            />
          </div>
        </li>
        <li class="hotline-item">
          <img src="../../assets/side3.png" alt="服务热线" />
          服务热线
          <div class="phone-popup">
            <i>{{ sidePhone.mainTitle }}</i>
            <p class="phone-popup-number">{{ sidePhone.phone }}</p>
          </div>
        </li>
        <li @click="scrollToTop">
          <img src="../../assets/side4.png" alt="置顶" />
          置顶
        </li>
      </ul>
    </div>

    <!-- 在线咨询弹窗 -->
    <div class="consult-popup" v-show="isShowConsult" id="scrollContainer">
      <div class="popup-header">
        <h3>中模云有限公司</h3>
        <button class="close-btn" @click="toggleConsultPanel">×</button>
      </div>
      <div class="popup-meta">中模云管理为您服务</div>
      <div>
        <div class="chat-history" ref="chatHistory">
          <div
            style="
              padding: 20px;
              background: #ffffff;
              border-radius: 4px 4px 4px 4px;
            "
          >
            <div class="message">
              <p>
                {{ onlineFixed.content | setText }}
              </p>
              <div style="margin: 20px 0">
                <p style="color: #000219">
                  咨询电话:
                  <i style="color: #317afa">{{ onlineFixed.phone }}</i>
                </p>
              </div>
              <p>
                <i style="color: #000219">商务对接:</i>
                {{ onlineFixed.dock }}
              </p>
            </div>
          </div>
        </div>
        <div class="chat-problom">
          <div
            style="
              padding: 20px;
              background-color: #ffffff;
              border-radius: 17px 17px 17px 17px;
            "
          >
            <p style="margin-bottom: 5px; font-size: 14px; font-weight: 700">
              请点击下面问题了解
            </p>
            <div
              v-for="(item, index) in onlineAnswer.list"
              :key="index"
              style="margin: 5px 0"
              @click="handleClickProblem(item.answer)"
            >
              {{ index + 1 }} : {{ item.problem }}
            </div>
          </div>
        </div>
        <div class="chatanswer" v-for="(answer, i) in answerList" :key="i">
          <p>{{ answer }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getConf } from "../../api/article";
export default {
  name: "BackTop",
  data() {
    return {
      BASE_URL: process.env.VUE_APP_API_BASE_URL,
      sidePhone: {},
      sideCard: {},
      onlineFixed: { content: "" },
      onlineAnswer: { list: [] },
      isShowConsult: false,
      inputValue: "",
      answerList: [],
    };
  },
  mounted() {
    this.fetchHomeConf();
  },
  filters: {
    setText(val) {
      return val
        .replace(/<(p|div)[^>]*>(<br\/?>|&nbsp;)<\/\1>/gi, "\n")
        .replace(/<br\/?>/gi, "\n")
        .replace(/<[^>/]+>/g, "")
        .replace(/(\n)?<\/([^>]+)>/g, "")
        .replace(/\u00a0/g, " ")
        .replace(/&nbsp;/g, " ")
        .replace(/<img[^>]+src\\s*=\\s*['\"]([^'\"]+)['\"][^>]*>/g, "")
        .replace(/<\/?(img|table)[^>]*>/g, "") // 去除图片和表格
        .replace(/<\/?(a)[^>]*>/g, ""); //  去除a标签
    },
  },
  methods: {
    handleClickProblem(answer) {
      this.answerList.push(answer);
      this.$nextTick(() => {
        this.scrollToChatBottom();
      });
    },

    scrollToChatBottom() {
      const container = document.getElementById("scrollContainer");
      container.scrollTop = container.scrollHeight;
    },
    async fetchHomeConf() {
      try {
        const response = await getConf();
        this.sidePhone = JSON.parse(response.data.sidePhone) || {};
        this.sideCard = JSON.parse(response.data.sideCard) || {};
        this.onlineFixed = JSON.parse(response.data.onlineFixed) || {
          content: ""
        };
        this.onlineAnswer = JSON.parse(response.data.onlineAnswer) || {
          list: [],
        };
      } catch (error) {
        console.error("页面初始化获取配置失败", error);
      }
    },
    toggleConsultPanel() {
      this.isShowConsult = !this.isShowConsult;
      if (this.isShowConsult) {
        this.$nextTick(() => {
          this.$refs.chatHistory.scrollTop =
            this.$refs.chatHistory.scrollHeight;
        });
      }
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    formatTime(time) {
      const now = new Date();
      const today = new Date(now.toDateString());
      const msgDate = new Date(time.toDateString());
      if (msgDate.getTime() === today.getTime()) {
        return time.toLocaleTimeString();
      } else {
        return time.toLocaleString();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@mixin backgroundImage($url) {
  background-image: url($url);
  background-repeat: no-repeat;
  background-size: 100%;
}

.back-top {
  position: fixed;
  right: 0px;
  bottom: 100px;
  display: flex;
  flex-direction: column;
  width: 60px;
  height: 240px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 1px rgba(45, 79, 112, 0.16);
  border-radius: 30px 30px 30px 30px;
  z-index: 999;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

ul li {
  width: 60px;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 12px;
  color: #000a25;
  cursor: pointer;
  transition: background-color 0.2s;
  position: relative; /* 用于弹窗定位 */
}

ul li:hover {
  background-color: #f5f7fa;
}

ul li img {
  width: 28px;
  height: 28px;
  margin-bottom: 5px;
}
// 微信弹窗隐藏
.weath-popup {
  position: absolute;
  right: 70px; /* 显示在图标左侧 */
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  width: 158px;
  height: 200px;
  background: #ffffff;
  box-shadow: 0px 0px 8px 1px rgba(45, 79, 112, 0.16);
  border-radius: 8px 8px 8px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}
/* 鼠标移到微信图标上时显示弹窗 */
.weath-item:hover .weath-popup {
  opacity: 1;
  visibility: visible;
  transform: translate(0, -50%); /* 移动到正常位置 */
}
/* 电话号码弹窗（默认隐藏） */
.phone-popup {
  position: absolute;
  right: 70px; /* 显示在图标左侧 */
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  width: 160px;
  min-height: 80px;
  padding: 12px 0;
  background: #ffffff;
  box-shadow: 0px 0px 8px 1px rgba(45, 79, 112, 0.16);
  border-radius: 8px 8px 8px 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

/* 鼠标移到电话图标上时显示弹窗 */
.phone-popup-number {
  margin: 0;
  color: #005cef;
  font-weight: 700;
  line-height: 1.6;
  text-align: center;
  white-space: pre-line;
}

.hotline-item:hover .phone-popup {
  opacity: 1;
  visibility: visible;
  transform: translate(0, -50%); /* 移动到正常位置 */
}

/* 在线咨询弹窗样式 */
.consult-popup {
  position: fixed;
  right: 70px;
  bottom: 100px;
  width: 362px;
  height: 640px;
  background: #f7f8fa;
  border: 1px solid #eee;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  overflow-y: auto;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background: #317afa;
  color: #fff;
  border-radius: 8px 8px 0 0;
}

.popup-header h3 {
  font-size: 16px;
  font-weight: 400;
  margin: 0;
}

.close-btn {
  background: transparent;
  border: none;
  color: #fff;
  font-size: 18px;
  cursor: pointer;
}

.popup-meta {
  width: 132px;
  height: 28px;
  background: #d9deec;
  border-radius: 17px 17px 17px 17px;
  text-align: center;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 400;
  color: #ffffff;
  margin: 12px auto;
}

.chat-history {
  flex: 1;
  padding: 0 20px;
  overflow-y: auto;
}
.message {
  position: relative;
}
.message::before {
  content: "";
  position: absolute;
  top: -10px; /* 三角在容器上方，需调整定位 */
  left: -33px; /* 三角水平位置 */
  /* 核心：通过边框控制三角形状 */
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid #ffffff; /* 三角颜色与容器一致 */
}
.message p {
  font-weight: 400;
  font-size: 16px;
}

.message-time {
  font-size: 12px;
  color: #999;
  text-align: right;
  margin-top: 5px;
}

::v-deep .phone-tag {
  display: block;
  margin: 40px 0; // 上下各 40px 间距
}
.chat-problom {
  position: relative;
  padding: 0 20px;
  margin-top: 12px;
}
.chat-problom::before {
  content: "";
  position: absolute;
  top: 15px; /* 三角在容器上方，需调整定位 */
  left: 8px; /* 三角水平位置 */
  /* 核心：通过边框控制三角形状 */
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid #fff; /* 三角颜色与容器一致 */
}
.chatanswer {
  padding: 0 20px;
  margin: 12px 0;
  position: relative;
}
.chatanswer p {
  padding: 12px 20px;
  background-color: #e8efff;
  border-radius: 17px 17px 17px 17px;
}
.chatanswer::before {
  content: "";
  position: absolute;
  top: 15px; /* 三角在容器上方，需调整定位 */
  right: 6px; /* 三角水平位置 */
  /* 核心：通过边框控制三角形状 */
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 15px solid #e8efff; /* 三角颜色与容器一致 */
}
/* 移动端适配 */
@media (max-width: 768px) {
  .phone-popup p {
    margin: 0;
    cursor: pointer;
  }
  .phone-popup p:active {
    color: #e0e0e0;
  }
}
</style>
